import fx from "utils/fx";
import AxiosInterceptor from "api/interceptor";

const warehouse = new AxiosInterceptor();

export default {
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return new Promise((resolve, reject) => {
      warehouse
        .get("/warehouse?" + qstr)
        .then((res) => {
          if (res.data.success) {
            if (res.data.data && res.data.data.length > 0) {
              res.data.data.map((el) => {
                el.created_at = fx.formatDateTime(
                  el.created_at,
                  this.$store.getters.timezone
                );
              });
            } else {
              if (res.data.data.data && res.data.data.data.length > 0) {
                res.data.data.data.map((el) => {
                  el.created_at = fx.formatDateTime(
                    el.created_at,
                    this.$store.getters.timezone
                  );
                });
              }
            }
          }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  find(id) {
    return warehouse.get("/warehouse/" + id);
  },
  create(inputs) {
    return warehouse.post("/warehouse", inputs);
  },
  update(id, inputs) {
    return warehouse.put("/warehouse/" + id, inputs);
  },
  delete(id) {
    return warehouse.delete("/warehouse/" + id);
  },
  getAllSettings() {
    return warehouse.get("/warehouse/settings");
  },
  updateSettings(data) {
    return warehouse.put("/warehouse/settings", data);
  },
  getProductFromWareHouse() {
    return warehouse.get("/warehouse/products");
  },
};
